import {
  CreatePromoCodeEntity,
  PromoCodeEntity,
  PromoCodeParams,
} from '@/pages/privatePages/promoCode/types';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { PreviewResponse } from '@/queries/promoCode.query';
import { QueryFunctionContext } from '@tanstack/react-query';
import { QueryKeyTypes } from '@/queries/queryKeys';

class PromoCodeServiceClass extends BaseService<
  'promoCode',
  PromoCodeEntity,
  CreatePromoCodeEntity
> {
  constructor() {
    super('promo-code');
  }

  getPriceAfterApplyPromoCode = (
    context: QueryFunctionContext<QueryKeyTypes<PromoCodeParams>>,
  ): Promise<PreviewResponse> => {
    const { params } = context.queryKey[0];
    return APIService.get(this.path + '/preview', { params });
  };
}
export const promoCodeService = new PromoCodeServiceClass();
